import Renderer from './Renderer';
// import Layer from './Layer3D';
import Transform from '../transformNodes/Transform3D';
import Scene from '../Scene3D';
import { TextureSet, EMPTY_TEXTURE_SET } from '../rendering/Texture';

import opacities from './OPACITIES';
const opaque = opacities.OPAQUE;

export default class Object3D {
	transform: Transform;
	// layer: Layer;
	scene: Scene | null;

	textureSet: TextureSet;
	opacity: opacities;
	castShadow: boolean;
	receiveShadow: boolean;

	displayListReference: any;

	constructor () {
		this.transform = new Transform();
		// this.layer = new Layer(this);
		this.scene = null;

		this.textureSet = EMPTY_TEXTURE_SET;
		this.opacity = opaque;
		this.castShadow = true;
		this.receiveShadow = true;

		this.displayListReference = null;
	}

	// render (renderer: Renderer) {
	// 	// this.prerender();
	// 	// this.layer.render(renderer, shaderName, setupEnvironment, transluscentObjects);
	// 	// this.postrender();
	// }

	addChild (child: Object3D) {
		this.transform.addChild(child.transform);
		// this.layer.addChild(child.layer);
		if (this.scene !== null) {
			this.scene.addObject(child);
		}
	}

	removeFromParent () {
		this.transform.removeFromParent();
		// this.layer.removeFromParent();
		if (this.scene !== null) {
			this.scene.removeObject(this);
		}
	}
}
